import { ReactNode, useEffect } from "react";

import { useAppRouter } from "~/hook/base/useAppRouter.ts";
import { mutateRelatedPokeList } from "~/hook/domain/useRelatedPokeList";
import { serviceWorker } from "~/service/dom";

interface Message {
  data: {
    url: string;
  };
  type: "NAVIGATE" | "REVALIDATE_RELATED_POKES";
}

export const MessageProvider = ({ children }: { children: ReactNode }) => {
  const { push } = useAppRouter();

  useEffect(() => {
    const listener = (event: MessageEvent<Message>) => {
      switch (event.data.type) {
        case "NAVIGATE":
          push({ pathname: event.data.data.url });
          break;
        case "REVALIDATE_RELATED_POKES":
          void mutateRelatedPokeList();
          break;
      }
    };
    serviceWorker?.addEventListener("message", listener);
    return () => {
      serviceWorker?.removeEventListener("message", listener);
    };
  }, [push]);

  return children;
};
